import { render, staticRenderFns } from "./Plan.pug?vue&type=template&id=62321c91&lang=pug&external"
import script from "./Plan.js?vue&type=script&lang=js&external"
export * from "./Plan.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports